import React, {Component} from "react"
import {Entity} from 'aframe-react'

class AspectImage extends Component {

    render() {

        let ar = this.props.image.height / this.props.image.width 

        this.h = this.props.height;
        this.w = this.h / ar

        if (this.props.getSize) this.props.getSize(this.w, this.h)

        return (
            <Entity
                primitive="a-image"

                height={this.h} width={this.w}

                material={{
                    flatShading: true,
                    side: "front",
                }}

                src={this.props.image.src}
            />
        )
    }
}

AspectImage.defaultProps = {
    height: 3,
}


export default AspectImage


// WEBPACK FOOTER //
// ./src/components/AspectImage.js